import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/admin-img/email-sent-icon.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "email-sent-container" }
const _hoisted_4 = { class: "admin-white-bg email-sent-content" }
const _hoisted_5 = { class: "email-sent-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "email-sent-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Email Sent Icon"
  })
], -1)
const _hoisted_7 = { class: "email-sent-text" }
const _hoisted_8 = { class: "primary-btn-container" }
const _hoisted_9 = { class: "admin-site-footer" }
const _hoisted_10 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants.EMAIL_HAS_BEEN_SENT_TEXT), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.WE_HAVE_SENT_YOU_AN_EMAIL_AT_TEXT), 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.email), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.PLEASE_CLICK_THE_LINK_TO_RESET_THE_PASSWORD_TEXT), 1)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.THE_LINK_WILL_BE_VALID_FOR_5_MINUTES_TEXT), 1),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.constants.DID_NOT_RECEIVE_THE_EMAIL_TEXT) + " ", 1),
              _createElementVNode("a", {
                href: "#",
                id: "resendEmailLink",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
              }, _toDisplayString(_ctx.constants.RESEND_EMAIL_LINK), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              id: "emailSentSubmitBtn",
              class: "primary-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/authority/login')))
            }, _toDisplayString(_ctx.constants.LOGIN_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}